import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import user from './modules/user';
import contract from './modules/contract';
import city from './modules/city';
import district from './modules/district';

import notification from './modules/notification';
import message from './modules/message';


import classRoom from './modules/class-room';
import lessonArea from './modules/lesson-area';
import lessonGroup from './modules/lesson-group';
import lesson from './modules/lesson';
import lessonSubject from './modules/lesson-subject';
import lessonTeacher from './modules/lesson-teacher';
import lessonKBS from './modules/lesson-kbs';
import howToStudy from './modules/how-to-study';
import packages from './modules/package';
import student from './modules/student';
import teacher from './modules/teacher';
import appointment from './modules/appointment';
import globalFileCategory from './modules/global-file-category';

let isUpdating = false;

const store = createStore({
    modules: {
        user,
        contract,
        city,
        district,
        notification,
        message,
        classRoom,
        lessonArea,
        lessonGroup,
        lesson,
        lessonSubject,
        lessonTeacher,
        lessonKBS,
        howToStudy,
        packages,
        student,
        teacher,
        appointment,
        globalFileCategory
    },
    plugins: [
        createPersistedState({
            storage: window.localStorage
        }),
        //createPersistedState({
        //    storage: {
        //        getItem: key => localStorage.getItem(key),
        //        setItem: (key, value) => {
        //            if (!isUpdating) {
        //                localStorage.setItem(key, value);
        //                window.dispatchEvent(new Event('storage'));
        //            }
        //        },
        //        removeItem: key => {
        //            if (!isUpdating) {
        //                localStorage.removeItem(key);
        //                window.dispatchEvent(new Event('storage'));
        //            }
        //        },
        //    }
        //}),
        //createPersistedState({
        //    paths: ['notification', 'message'],
        //    storage: {
        //        getItem: key => sessionStorage.getItem(key),
        //        setItem: (key, value) => sessionStorage.setItem(key, value),
        //        removeItem: key => sessionStorage.removeItem(key)
        //    }
        //}),
    ]
});
// Storage de�i�ikliklerini yakala ve Vuex store'u g�ncelle
window.addEventListener('storage', () => {
    const storedState = JSON.parse(localStorage.getItem('vuex'));
    if (storedState) {
        store.replaceState(Object.assign(store.state, storedState));
    }
});
//window.addEventListener('storage', (event) => {
//    const { key, value } = event;
//    if (key === "vuex") {
//        if (!isUpdating) {
//            isUpdating = true;
//            //if (value) {
//            //    const parsedData = JSON.parse(value);
//            //    Object.keys(parsedData).forEach(moduleName => {
//            //        if (store.hasModule(moduleName)) {
//            //            const moduleData = parsedData[moduleName];
//            //            Object.keys(moduleData).forEach(stateKey => {
//            //                const mutationType = `${moduleName}/set${stateKey.charAt(0).toUpperCase() + stateKey.slice(1)}`;
//            //                if (store._mutations[mutationType]) {
//            //                    const currentState = store.state[moduleName][stateKey];
//            //                    if (currentState !== moduleData[stateKey]) {
//            //                        store.commit(mutationType, moduleData[stateKey]);
//            //                    }
//            //                }
//            //            });
//            //        }
//            //    });
//            //}
//            isUpdating = false;
//        }
//    }
//});
export default store;